const tabsContent = document.querySelectorAll(
	'.block-tabs-side-image__content'
);

const tabButtons = document.querySelectorAll(
	'.block-tabs-side-image-tab__content > .wp-block-button .wp-block-button__link'
);

const tabBlocks = document.querySelectorAll('.block-tabs-side-image');

const toggleTab = (e) => {
	e.preventDefault();

	const tabBlock = e.currentTarget.closest('.block-tabs-side-image');

	if (tabBlock) {
		// Deactivate all the things
		const activeLinks = tabBlock.querySelectorAll(
			'.wp-block-button__link.active'
		);

		if (activeLinks.length) {
			activeLinks.forEach((activeLink) => {
				if (activeLink !== e.currentTarget) {
					activeLink.classList.remove('active');
					tabBlock
						.querySelector('.block-tabs-side-image-tab.active')
						.classList.remove('active');
				}
			});
		}

		// Activate clicked link and associated __wrapper
		const selectedID = e.currentTarget.getAttribute('data-id');
		e.currentTarget.classList.add('active');
		// e.currentTarget.parentElement.parentElement.classList.add('active');
		tabBlock
			.querySelector(
				`.block-tabs-side-image-tab[data-id="${selectedID}"]`
			)
			.classList.add('active');
	}
};

const initTabs = () => {
	if (tabButtons.length) {
		tabButtons.forEach((tabButton) => {
			tabButton.addEventListener('click', toggleTab);
		});
	}

	if (tabBlocks.length) {
		// Loop thru each .block-tabs-side-image block
		tabBlocks.forEach((tabBlock) => {
			const tabs = tabBlock.querySelectorAll(
				'.block-tabs-side-image-tab'
			);
			if (tabs.length) {
				// Loop thru each tab in the block
				tabs.forEach((tab, index) => {
					// give initialized class and set 1st button/tab to active
					const tabButton = tab.querySelector(
						'.wp-block-button__link'
					);

					const tabTitle = tab.getAttribute('data-tab-title');
					if (tabButton) {
						tabButton.classList.add('initialized');
						tabButton.setAttribute('data-tab-title', tabTitle);
						tabButton.innerHTML = tabTitle;
					}

					if (0 === index) {
						tab.classList.add('active');

						if (tabButton) {
							tabButton.classList.add('active');
						}
					}
				});
			}
		});
	}

	let i = 0;
	if (tabsContent.length) {
		// Iterate thru each Tabs block
		tabsContent.forEach((tabContent) => {
			// Grab all the links
			const tabControls = tabContent.querySelectorAll(
				'.block-tabs-side-image-tab__content > .wp-block-button .wp-block-button__link'
			);

			// Create a container for the links
			const tabControlsWrapper = document.createElement('div');
			tabControlsWrapper.classList.add(
				'block-tabs-side-image__controls-wrapper'
			);
			const tabControlsContainer = document.createElement('div');
			tabControlsContainer.classList.add(
				'block-tabs-side-image__controls'
			);

			// Give each link a unique ID and move into the container
			tabControls.forEach((tabControl) => {
				i++;
				tabControl.setAttribute('data-id', i);
				tabControl
					.closest('.block-tabs-side-image-tab')
					.setAttribute('data-id', i);
				tabControlsContainer.append(tabControl);
			});

			tabControlsWrapper.prepend(tabControlsContainer);
			tabContent.prepend(tabControlsWrapper);
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initTabs();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
